import React, { Component } from 'react';
import fetch from '../services/fetch'

import { Avatar, Icon, Menu, Dropdown } from 'antd';
import store from './../store'
import tabsAction from './../actions/tabs'

//icon
class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            session: JSON.parse(sessionStorage.session),
            website: this.isJson(sessionStorage.website) ? JSON.parse(sessionStorage.website) : {}
        }
    }

    isJson(data) {
        try {
            JSON.parse(data)
        } catch (e) {
            return false;
        }
        return true;
    }

    menu() {
        return (
            <Menu>
                <Menu.Item>
                    <a href="javascript:;" onClick={this.logout.bind(this)}>退出</a>
                </Menu.Item>
            </Menu>
        )
    }

    logout() {
        //ciqa系统
        // sessionStorage.removeItem('session');
        // sessionStorage.removeItem('keywords');
        // window.location.hash = '/';
        // window.location.reload();

        //测评系统
        const tabs = store.getState().tabs;
        tabs.forEach(tab => {
            store.dispatch(tabsAction.remove(tab))
        });
        fetch.post('employee/logout?').then((res) => {
            if (res) {
                sessionStorage.removeItem('session');
                sessionStorage.removeItem('keywords');
                if (res.payload.data) {
                    const url = res.payload.data
                    window.location.href = url
                } else {
                    window.location.hash = '/';
                    window.location.reload();
                }
            } else {
                Modal.error({
                    title: '退出失败',
                    content: '退出失败',
                    okText: '确认'
                })
            }
        })
    }

    render() {
        const { session } = this.state;

        return (
            <div className="root-header">
                <i><img src={this.state.website.schoolLogo} /></i><h1>{session.account.systemName}</h1>
                <span className="user">
                    <span className="root-header-termname">当前是：{session.account.termName} </span>
                    <Dropdown overlay={this.menu()}>
                        <a className="ant-dropdown-link" href="javascript:;">
                            {session.account.realName} <Icon type="down" />
                        </a>
                    </Dropdown>
                </span>
            </div>
        )
    }
}

export default Header;